/* eslint-disable @typescript-eslint/no-unused-vars */
export enum SoilType {
  Precast = 'Pre Cast',
  NativeSoil = 'Native Soil',
}
